import React, { useState, useRef } from 'react';
import Headline from 'headline';
import stickerData from 'data/sticker.json';
import Icon from 'icon';
import { navigate } from 'gatsby';
import s from './infl-sticker.module.scss';

export default function InfluencersSticker(props) {
  const [left, setLeft] = useState(0);
  const [wait, setWait] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [initDrag, setInitDrag] = useState(null);
  const sticker = useRef(null);

  // handlers
  const handleUp = () => {
    // on Up, change the store's value
    setDragging(false);
    document.removeEventListener('mouseup', handleUp);
    document.removeEventListener('touchend', handleUp);
  };
  const handleMouseDown = e => {
    setDragging(true);
    setInitDrag(e.clientX);
    document.addEventListener('mouseup', handleUp);
  };

  const handleMouseMove = e => {
    if (dragging && !wait) {
      if (e.clientX > initDrag) {
        if (left !== 0) {
          setLeft(left + 320);
          setInitDrag(left + 320);
        }
      } else {
        setLeft(left - 320);
        setInitDrag(left - 320);
      }
      setWait(true);
      setTimeout(() => {
        setWait(false);
      }, 100);
    }
  };

  return (
    <section
      className={s.root}
      onMouseDown={e => handleMouseDown(e)}
      onMouseMove={e => handleMouseMove(e)}
      draggable="false"
    >
      <div className={s.wrapper}>
        <div className={s.listWrapper}>

          <ul
            draggable="false"
            ref={sticker}
            className={`${s.list}`}
            style={{ transform: `translateX(${left}px)` }}
          >
            {stickerData.map(
            ({
              firstName,
              lastName,
              username,
              qualityScore,
              country,
              featuredImage
            }) => (
              <li
                draggable="false"
                key={username}
                className={s.card}
              >
                <img
                  draggable="false"
                  className={s.image}
                  src={featuredImage?.url}
                  alt={featuredImage?.url}
                />
                <div
                  className={s.infoWrapper}
                  draggable="false"
                >
                  <Headline
                    draggable="false"
                    className={s.title}
                    h6
                    secondary
                    el="a"
                    href={`/influencers/${username.replace('@', '')}`}
                  >
                    {`${firstName} ${lastName?.split(' ').splice(0, 1)}`}
                  </Headline>
                  <div
                    className={s.item}
                    draggable="false"
                  >
                    <Icon icon="link" />
@
                    {username}
                  </div>
                  <div
                    className={s.item}
                    draggable="false"
                  >
                    <Icon icon="location-small" />
                    {country?.name}
                  </div>
                </div>
                <div
                  className={s.quality}
                  draggable="false"
                >
                  {qualityScore}
                  <span>of 100</span>
                </div>
              </li>
            )
            )}
          </ul>
        </div>
      </div>
    </section>
  );
}
